import React from 'react';
import { History } from 'history';
import { Input, InputNumber, InputMultiline, InputFile, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import BaseView from '../base/base-view.component';
import Model from './quizanswer-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import QuizquestionModel from '../quizquestion/quizquestion-model';
import QuizresultChecklist from '../quizresult/quizresult-checklist.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class QuizanswerCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private historyState: any = this.props.history.location.state;
    
    private onLoadQuizquestion = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'quizquestion': data?.id, 'quizquestionCaption': data?.name || ''  }  });
    }  

    private onLoadQuizresult = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'quizresult': data || [], 'quizresultCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }  

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{files: data, ref: Model.endPointMedia, field:'image'}}});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    public componentDidMount(): void {    
        this.onLoadQuizquestion({'id': this.historyState?.id});
    }

    render() {
        return (
            //editable.. 
            <>
            {this.historyState?.id > 0 &&
            <BaseView history={this.props.history} caption=''
                model={QuizquestionModel} onLoad={this.onLoadQuizquestion}/>
            }    
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onError={this.onError}>              
          
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <Input name='title' label='Title' value={this.state.datarow.title} error={this.state.errors?.title} onChange={this.onChange} />
                <InputMultiline name='content' label='Content' value={this.state.datarow.content} error={this.state.errors?.content} onChange={this.onChange} />
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                <Input name='answer' label='Answer' value={this.state.datarow.answer} error={this.state.errors?.answer} onChange={this.onChange} />
                <InputNumber name='value' label='Value' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
                <InputPicklist name='quizresult' label='Quiz Result List' value={this.state.datarow.quizresult} caption={this.state.datarow.quizresultCaption} disableAutoClose clearValue={this.onLoadQuizresult} error={this.state.errors?.quizresult} onChange={this.onChange} >
                    <QuizresultChecklist history={this.props.history} currentId={this.state.datarow.quizresult} onLoad={this.onLoadQuizresult} disableBackButton/>
                </InputPicklist> 
            </BaseCreate>
            </>
        );
    }     
     
}